import FormControl from "common/components/FormControl/FormControl";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CrudForm from "common/components/Crud/CrudForm";
import type { New } from "types";

type Props = {
  onSubmit: (values: any) => any;
  onCancel?: () => void;
  item?: New;
};

function NewsForm({ onSubmit, onCancel, item }: Props) {
  const { t } = useTranslation();

  const initialValues = useMemo(
    () =>
      item?.id
        ? {
            ...item,
          }
        : {
            isExternal: true,
          },
    [item],
  );

  return (
    <CrudForm
      onSubmit={onSubmit}
      onCancel={onCancel}
      initialValues={initialValues}
      headerIcon="IoMdMegaphone"
      i18nNamespace="news"
      render={(values) => (
        <div className="flex flex-col gap-4 white-box">
          <div className="flex flex-row gap-4">
            <FormControl
              name="image"
              titleKey="news.image"
              type="image"
              labelIcon="PhotoIcon"
              containerStyle="min-w-[200px]"
              className="border border-slate-200 rounded-lg overflow-hidden"
            />
            <div className="flex flex-col flex-1 gap-2">
              <FormControl name="name" title={t("news.name")} required />
              <FormControl
                name="isExternal"
                type="checkbox"
                title={t("news.isExternal")}
              />
              {values?.isExternal ? (
                <FormControl
                  name="externalLink"
                  title={t("news.externalLink")}
                />
              ) : (
                <>
                  <FormControl
                    name="content"
                    type="richtext"
                    title={t("news.content")}
                  />
                  <FormControl
                    name="images"
                    type="file"
                    title={t("news.images")}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      )}
    />
  );
}

export default NewsForm;
